import React, { useState, useEffect } from 'react';
import '../DiagonalScrollComponent.css';
import realisation from '../assets/réalisation-min.png';

const DiagonalScrollComponent = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const leftStyle = {
    transform: `translateX(${Math.min(scrollY / 5, 100)}px)`,
  };

  const rightStyle = {
    transform: `translateX(${-Math.min(scrollY / 5, 100)}px)`,
  };

  return (
    <div className="realisation-section">
      {/* Titre et introduction */}
      <div className="rea-section">
        <h2 className="values-title">Nos réalisations</h2>
        <div className="separator-line"></div>
        <p className="rea-description">
          Nos réalisations témoignent de notre expertise et de notre passion pour le secteur du BTP. Découvrez comment nos projets
          transforment le paysage, alliant innovation, durabilité et esthétique pour créer des infrastructures remarquables.
        </p>
      </div>

      {/* Conteneur du défilement diagonal */}
      <div className="scroll-container">
        <div className="left-section" style={leftStyle}>
          <div className="left-content">
            <p>
              Découvrez comment nos projets transforment le secteur du BTP, alliant innovation, durabilité et esthétique pour des infrastructures d'exception.
            </p>
            <a href="/nos-realisations">
            <button className="learn-more-button">En savoir plus</button>
            </a>          
          </div>
        </div>
        <div className="right-section" style={rightStyle}>
          <img src={realisation} alt="photo de réalisation" className="realisation-image" />
        </div>
      </div>
    </div>
  );
};

export default DiagonalScrollComponent;
